import { UserTeamInfo } from "JS/Models";
import { config, encryptAndDecryptXorString } from "JS/Config";

export const isSubscribed = (
    includedSubscriptions: string[],
    teamInfo: UserTeamInfo,
) =>
    includedSubscriptions === undefined ||
    teamInfo?.activeSubscriptions === undefined ||
    teamInfo?.activeSubscriptions?.some((sub) =>
        includedSubscriptions
            ?.map((s) => s.toLowerCase())
            ?.includes(sub.toLowerCase()),
    );

export const openExternalLink = (
    url: string,
    isConsentForm: boolean = false,
) => {
    if (url)
        window.open(
            url,
            isConsentForm ? "_self" : "_blank",
            "noopener,noreferrer",
        );
};

export const openSSOLink = (place: string, isConsentForm: boolean) => {
    const memberId = config.user?.memberId;
    const encryptedMemberId = encryptAndDecryptXorString(
        memberId,
        config.s3.xor,
    );
    const url = `${process.env.REACT_APP_BASE_API_URL}/sso/redirectURL/${place}/LTD?memberId=${encryptedMemberId}`;
    openExternalLink(url, isConsentForm);
};
